import * as $ from 'jquery';
import _, {
  shuffle,
  reverse,
  sampleSize,
  mergeWith,
  isNil,
  isArray,
  isEqual,
  merge,
  defaultsDeep,
  cloneDeep,
  isString,
} from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';

import FontFaceObserver from 'fontfaceobserver';

import defConfig from './cjsDefaultConfig';

import * as fJS from './cjsRoot/fJS';
import { cjsSound } from './cjsRoot/cjsSound';
import { cjsGroup } from './cjsRoot/cjsGroup';
import { DynamicClass } from './cjsRoot/cjsBase';

import { cjsDnD } from './cjsEngines/cjsDnD';
import { cjsSorting } from './cjsEngines/cjsSorting';
import { cjsRotate } from './cjsEngines/cjsRotate';
import { cjsMixer } from './cjsEngines/cjsMixer';

import { cjsConnect } from './cjsEngines/cjsConnect';

import { cjsClock } from './cjsEngines/cjsClock';

import { cjsSelect } from './cjsEngines/cjsSelect';
import { cjsPuzzle } from './cjsEngines/cjsPuzzle';

import { cjsMemo } from './cjsEngines/cjsMemo';
//import { cjsMahjong } from './cjsMahjong';
import { cjsHangman } from './cjsEngines/cjsHangman';

import { cjsMaze } from './cjsEngines/cjsMaze';
import { cjsMazeDraw } from './cjsEngines/cjsMazeDraw';
import { cjsTraceDraw } from './cjsEngines/cjsTraceDraw';

export class cjsStage {
  _id;
  _engine;
  _stage;
  _sounds;
  _ticker;
  _touch;
  _width;
  _height;
  _offset;
  _removeInCorrects;
  _backToSource;
  _bruteForce;
  _autoCheckAllCorrect;
  _removeAllFromBadTarget;
  _removeAllForBadCount;
  _correctBlock;
  _otherProperty;
  _mousedown;
  _mixins;

  _dev = false;

  _groups;
  movesTo = [];

  _defConfig;
  _shuffleGroups;
  _fixTab;
  _fixProperty;
  _listener = {};
  _promises;
  _fonts = new Map();

  constructor(initData, mixin) {
    if (process.env.NODE_ENV === 'development') {
      console.log('initData', initData);
    }
    this._initData = cloneDeep(initData);
    this._mixins = mixin;
    // FIXME: extract unnecessary code to function and make it as a feature
    /**
     * load defaultConfig from json file ( deprecated - shuld be newer used )
     */
    if (typeof initData.defaultConfig === 'string' && initData.defaultConfig.length > 0) {
      let rawdata = {};
      if (process.env.NODE_ENV != 'production' && !process.env.VUE_APP_IS_WEB) {
        const fs = require('fs');
        rawdata = fs.readFileSync('./' + initData.defaultConfig);
      }
      let tmp = cloneDeep(defConfig);
      merge(defConfig, JSON.parse(rawdata));
      if (fJS.isNumeric(defConfig.container.margin)) {
        defConfig.container.margin = {
          top: defConfig.container.margin,
          left: defConfig.container.margin,
          right: defConfig.container.margin,
          bottom: defConfig.container.margin,
        };
      } else {
        defConfig.container.margin.top = !fJS.isNumeric(defConfig.container.margin.top)
          ? tmp.container.margin.top
          : defConfig.container.margin.top;
        defConfig.container.margin.left = !fJS.isNumeric(defConfig.container.margin.left)
          ? tmp.container.margin.left
          : defConfig.container.margin.left;
        defConfig.container.margin.right = !fJS.isNumeric(defConfig.container.margin.right)
          ? tmp.container.margin.right
          : defConfig.container.margin.right;
        defConfig.container.margin.bottom = !fJS.isNumeric(defConfig.container.margin.bottom)
          ? tmp.container.margin.bottom
          : defConfig.container.margin.bottom;
      }
      if (fJS.isNumeric(defConfig.container.padding)) {
        defConfig.container.padding = {
          top: defConfig.container.padding,
          left: defConfig.container.padding,
          right: defConfig.container.padding,
          bottom: defConfig.container.padding,
        };
      } else {
        SoundJS(defConfig.container.padding.left) ? tmp.container.padding.left : defConfig.container.padding.left;
        defConfig.container.padding.right = !fJS.isNumeric(defConfig.container.padding.right)
          ? tmp.container.padding.right
          : defConfig.container.padding.right;
        defConfig.container.padding.bottom = !fJS.isNumeric(defConfig.container.padding.bottom)
          ? tmp.container.padding.bottom
          : defConfig.container.padding.bottom;
      }
    }

    this._defConfig = cloneDeep(defConfig);
    if (typeof this._defConfig.text.font !== 'string' || this._defConfig.text.font.length === 0) {
      this._defConfig.text.font = this._mixins.getDefaultFont;
    }

    if (!this._checkEngine(this.config.mixinEngine)) return false;
    if (!fJS.isNumeric(this.defConfig.speedAnimate)) throw 'Wartość speedAnimate nie jest prawidłowa';

    let fName = [];
    this._fonts = [];
    this._findFonts(this._fonts, fName, this.config);
    if (this._fonts.length === 0 || fName.includes(this._defConfig.text.font) === false)
      this._fonts.push(new FontFaceObserver(this._defConfig.text.font).load());

    this._sounds = new cjsSound();
    this._sounds.init();

    this._stage = new createjs.Stage(
      typeof mixin.idCanvas == 'string' && mixin.idCanvas.length > 0 ? mixin.idCanvas : 'gameCanvas'
    );

    this.sounds.Sound.alternateExtensions = ['mp3', 'ogg'];
    this.stage.mouseMoveOutside = true;
    this.stage.snapToPixelEnabled = true;

    this._ticker = createjs.Ticker;
    this.ticker.timingMode = createjs.Ticker.RAF;
    this.ticker.framerate = this.defConfig.framerate;
    if (this.ticker.hasEventListener('tick')) this.ticker.removeAllEventListeners();
    this.ticker.addEventListener(
      'tick',
      function (self, e) {
        self.tick(e);
      }.bind({}, this)
    );
  }

  initGame() {
    this._mousedown = false;
    this.listener = {};
    this.promises = [];

    this._setStage();
    this._loadStage();

    if (createjs.Touch.isSupported()) {
      this._touch = createjs.Touch.enable(this.stage);
      console.log('Touch is supported: ' + createjs.Touch.isSupported());
    }
  }

  runLoad(stage) {
    let bmp = new createjs.Bitmap('./src/renderer/components/TrGame/mixins/cjsImg/loading.gif');
  }

  runFunctionEngine(fnName) {
    DynamicClass.prototype.fn(this._engine, fnName, this);
  }

  checkGameAction() {
    return DynamicClass.prototype.fn(this._engine, 'checkGameAction', this);
  }

  _destroyKatex() {
    if (!(this._initData.katexData instanceof Map)) {
      return;
    }
    [...this._initData.katexData].forEach((katex) => {
      console.log(katex);
      /// remove all children from html tags
    });
    this._initData.katexData.clear();
  }

  resetGameAction() {
    try {
      delete this.movesTo;
      delete this._groups;
      delete this.listener;
      delete this._promeses;
      delete this._initData.katexData;

      this._stage.removeAllChildren();
      this._stage.removeAllEventListeners();
      this._sounds.Sound.removeAllSounds();

      //  DynamicClass.prototype.fn(this._engine, 'afterLoadSamples', this);
      DynamicClass.prototype.fn(this._engine, 'resetGameAction', this);
    } catch (e) {
      console.log(e);
    }
    this.initGame();
  }

  beforeDestroy() {
    try {
      if (!this._stage.canvas) {
        return;
      }
      this.sounds.Sound.removeAllSounds();

      if (this._ticker !== false || this.ticker.hasEventListener('tick')) this._ticker.removeAllEventListeners();

      if (this._touch === true) createjs.Touch.disable(this._stage);

      this._stage.removeAllChildren();
      this._stage.removeAllEventListeners();
      this._stage.canvas = null;
      this._stage._eventListeners = null;

      createjs.DisplayObject._hitTestCanvas = null;

      this._destroyKatex();
      this.movesTo.splice(0, this.movesTo.length);
      delete this._groups;
    } catch (e) {
      console.log(e);
    }
  }

  tick(e) {
    this.movesTo = Object.values(this.movesTo).filter((item) => {
      this._animate(item, {
        x: item.pos.x,
        y: item.pos.y,
        scaleX: typeof item.pos.scaleX != undefined && item.pos.scaleX != null ? item.pos.scaleX : undefined,
        scaleY: typeof item.pos.scaleY != undefined && item.pos.scaleY != null ? item.pos.scaleY : undefined,
        move: true,
      });

      return !(
        item.x == item.pos.x &&
        item.y == item.pos.y &&
        ((typeof item.pos.scaleX != undefined && item.pos.scaleX != null && item.container.scaleX == item.pos.scaleX) ||
          typeof item.pos.scaleX == undefined ||
          item.pos.scaleX == null) &&
        ((typeof item.pos.scaleY != undefined && item.pos.scaleY != null && item.container.scaleY == item.pos.scaleY) ||
          typeof item.pos.scaleY == undefined ||
          item.pos.scaleY == null)
      );
    });

    if (fJS.isNotEmptyObject(this.mousePoint)) {
      if (this.mousedown === true) {
        this.mousePoint.shape.x = this._stage.mouseX - this.offset.x;
        this.mousePoint.shape.y = this._stage.mouseY - this.offset.y;
        this.mousePoint.shape.visible = this.mousePoint.alwaysShow;
      } else {
        this.mousePoint.shape.visible = false;
      }
    }

    DynamicClass.prototype.fn(this.engine, 'tick', this);

    this.stage.update(e);
  }

  getMeasure(p, cont) {
    if (!Array.isArray(cont.children)) {
      let width = fJS.isNumeric(cont.width) ? cont.width : cont.getBounds() !== null ? cont.getBounds().width : 1,
        height = fJS.isNumeric(cont.height) ? cont.height : cont.getBounds() !== null ? cont.getBounds().height : 1;
      if (p.x1 === false || p.x1 > cont.x) p.x1 = cont.x;
      if (typeof cont._rectangle === 'object' && fJS.isNumeric(cont._rectangle.x) && p.x1 > cont._rectangle.x)
        p.x1 = cont._rectangle.x;
      if (p.x2 === false || p.x2 < cont.x + width) p.x2 = cont.x + width;
      if (p.y1 === false || p.y1 > cont.y) p.y1 = cont.y;
      if (typeof cont._rectangle === 'object' && fJS.isNumeric(cont._rectangle.y) && p.y1 > cont._rectangle.y)
        p.y1 = cont._rectangle.y;
      if (p.y2 === false || p.y2 < cont.y + height) p.y2 = cont.y + height;
      if (cont.textBaseline === 'middle') {
        p.y1 -= height;
      }
      if (cont.textAlign === 'left') {
        p.x2 += Math.abs(p.x1);
      }
    } else
      Object.values(cont.children).forEach((child) => {
        let width = fJS.isNumeric(child.width) ? child.width : child.getBounds() !== null ? child.getBounds().width : 1,
          height = fJS.isNumeric(child.height)
            ? child.height
            : child.getBounds() !== null
            ? child.getBounds().height
            : 1;
        if (Array.isArray(child.children) && child.children.length > 0) {
          let p1 = { x1: false, x2: false, y1: false, y2: false };
          this.getMeasure(p1, child);
        }
        // if (child.visible === false)

        if (p.x1 === false || p.x1 > child.x) p.x1 = child.x;
        if (typeof child._rectangle === 'object' && fJS.isNumeric(child._rectangle.x) && p.x1 > child._rectangle.x)
          p.x1 = child._rectangle.x;
        if (p.x2 === false || p.x2 < child.x + width) p.x2 = child.x + width;
        if (p.y1 === false || p.y1 > child.y) p.y1 = child.y;
        if (typeof child._rectangle === 'object' && fJS.isNumeric(child._rectangle.y) && p.y1 > child._rectangle.y)
          p.y1 = child._rectangle.y;
        if (p.y2 === false || p.y2 < child.y + height) p.y2 = child.y + height;
        if (child.textBaseline === 'middle') {
          p.y1 -= height;
        }
        if (child.textAlign === 'left') {
          p.x2 += Math.abs(p.x1);
        }
        if (fJS.searchTree(child, ['graphics', 'command']) && fJS.isNumeric(child.graphics.command.radius)) {
          if (p.x1 > child.x - child.width) p.x1 = child.x - child.width;
          if (p.x2 < child.x + child.width) p.x2 = child.x + child.width;
          if (p.y1 > child.y - child.height) p.y1 = child.y - child.height;
          if (p.y2 < child.y + child.height) p.y2 = child.y + child.height;
        }
      });
  }

  update() {
    this._stage.update();
  }

  stageMouseDown(e, data) {
    let stage = data.cjsStage;

    if (stage.mousedown === true) {
      e.stopPropagation();
      return;
    }

    stage.mousedown = true;
    stage.listener.set('pm', stage._stage.on('pressmove', stage._stageMouseMove, null, false, { cjsStage: stage }));

    e.stopPropagation();
  }

  _stageMouseMove(e, data) {
    let engine = data.engine,
      stage = data.cjsStage;
    if (stage.mousedown === false) {
      return false;
    }
  }

  stageMouseUp(e, data) {
    let engine = data.engine,
      stage = data.cjsStage;
    if (stage.mousedown !== true) {
      e.stopPropagation();
      return;
    }

    stage.mousedown = false;
    stage._stage.off('pressmove', stage.listener.get('pm'));

    if (fJS.isNotEmptyObject(stage.mousePoint)) {
      stage.mousePoint.shape.visible = false;
    }

    if (fJS.isNotEmptyObject(engine)) {
      stage.sounds.play(engine.idGroup + '.' + engine.id + '.mouseup');
    }
    e.stopPropagation();
  }

  getObjectUnderPoint(point, all, blocked) {
    let items = this._stage
      .getObjectsUnderPoint(point.x, point.y)
      .map((item) => item)
      .filter((item) => {
        let idGroup = typeof item.idGroup === 'string' ? item.idGroup : item.parent.idGroup,
          idItem = typeof item.idItem === 'string' ? item.idItem : item.parent.idItem;

        return !(
          typeof idGroup !== 'string' ||
          typeof idItem !== 'string' ||
          typeof this.groups[idGroup].items !== 'object' ||
          this.groups[idGroup].items === null ||
          typeof this.groups[idGroup].items[idItem] !== 'object' ||
          this.groups[idGroup].items[idItem] === null ||
          (this.groups[idGroup].items[idItem].block === true && blocked !== true)
        );
      })
      .map((item) => {
        return {
          idGroup: typeof item.idGroup === 'string' ? item.idGroup : item.parent.idGroup,
          idItem: typeof item.idItem === 'string' ? item.idItem : item.parent.idItem,
        };
      });

    return items.length === 0 ? false : all === true ? items : items[0];
  }

  setPropertyStyle(html, style) {
    for (let i in style) {
      html.style.setProperty(i, style[i]);
    }
  }

  cacheItem(item) {
    let p = { x1: false, x2: false, y1: false, y2: false };
    this.getMeasure(p, item._container);
    if (p.x1 === false || p.x2 === false || p.x1 === false || p.y2 === false) return;
    if (item._container.cacheId !== 0) item._container.uncache();
    item._container.cache(p.x1, p.y1, p.x2 - p.x1, p.y2 - p.y1);
    item._container.cacheMeasure = cloneDeep(p);
  }

  get id() {
    return this._id;
  }
  get engine() {
    return this._engine;
  }
  get stage() {
    return this._stage;
  }
  get ticker() {
    return this._ticker;
  }
  get config() {
    return this._initData;
  }
  get width() {
    return this._width;
  }
  get height() {
    return this._height;
  }
  get offset() {
    return this._offset;
  }
  get dev() {
    return this._dev;
  }
  get removeInCorrects() {
    return this._removeInCorrects;
  }
  get backToSource() {
    return this._backToSource;
  }
  get bruteForce() {
    return this._bruteForce;
  }
  get autoCheckAllCorrect() {
    return this._autoCheckAllCorrect;
  }
  get removeAllFromBadTarget() {
    return this._removeAllFromBadTarget;
  }
  get removeAllForBadCount() {
    return this._removeAllForBadCount;
  }
  get correctBlock() {
    return this._correctBlock;
  }
  get groups() {
    return this._groups;
  }
  set groups(v) {
    this._groups = v;
  }
  get defConfig() {
    return this._defConfig;
  }
  get otherProperty() {
    return this._otherProperty;
  }
  get mousedown() {
    return this._mousedown;
  }
  set mousedown(v) {
    this._mousedown = v;
  }
  get listener() {
    return this._listener;
  }
  set listener(v) {
    this._listener = v;
  }
  get promises() {
    return this._promises;
  }
  set promises(v) {
    this._promises = v;
  }
  get sounds() {
    return this._sounds;
  }
  set sounds(v) {
    this._sounds = v;
  }

  get colsConfig() {
    return fJS.searchTree(this.config.configGame, ['rulesGame', 'groupsConfig', 'positions']) &&
      fJS.isNumeric(this.config.configGame.rulesGame.groupsConfig.positions.columns)
      ? this.config.configGame.rulesGame.groupsConfig.positions.columns
      : fJS.searchTree(this.config.configGame, ['layout', 'groupsConfig', 'positions']) &&
        fJS.isNumeric(this.config.configGame.layout.groupsConfig.positions.columns)
      ? this.config.configGame.layout.groupsConfig.positions.columns
      : -1;
  }

  get rowsConfig() {
    return fJS.searchTree(this.config.configGame, ['rulesGame', 'groupsConfig', 'positions']) &&
      fJS.isNumeric(this.config.configGame.rulesGame.groupsConfig.positions.rows)
      ? this.config.configGame.rulesGame.groupsConfig.positions.rows
      : fJS.searchTree(this.config.configGame, ['layout', 'groupsConfig', 'positions']) &&
        fJS.isNumeric(this.config.configGame.layout.groupsConfig.positions.rows)
      ? this.config.configGame.layout.groupsConfig.positions.rows
      : -1;
  }

  _findFonts(fonts, fName, obj) {
    for (let key in obj) {
      if (typeof obj[key] === 'object') this._findFonts(fonts, fName, obj[key]);
      if (key === 'font' && fName.includes(obj[key]) === false) {
        fName.push(obj[key]);
        let font = new FontFaceObserver(obj[key]);
        fonts.push(font.load());
      }
    }
  }

  _loadStage() {
    let layout = this.config.configGame.layout;
    let rules = this.config.configGame.rulesGame;

    if (!fJS.isNotEmptyObject(this.config.configGame.layout)) throw 'Brak konfiguracji elementów gry';
    if (!fJS.isNotEmptyObject(rules)) throw 'Brak konfiguracji logiki gry';

    this.groups = {};
    this.movesTo = [];
    if (Array.isArray(this.defConfig.container.offset)) throw 'Błędna konfiguracja offset w pliku DefaultConfig';

    this._offsetGroups = [];
    this._offsetGroups.push(this.defConfig.container.offset);

    this._shuffleGroups = typeof rules.shuffleGroups === 'boolean' ? rules.shuffleGroups : this.defConfig.shuffleGroups;

    this._fixTab =
      fJS.searchTree(rules, ['groupsConfig', 'positions']) && Array.isArray(rules.groupsConfig.positions.fixTab)
        ? rules.groupsConfig.positions.fixTab
        : [];

    this._fixProperty =
      fJS.searchTree(rules, ['groupsConfig']) && Array.isArray(rules.groupsConfig.fixProperty)
        ? cloneDeep(rules.groupsConfig.fixProperty)
        : [];

    if (
      fJS.searchTree(layout, ['groupsConfig']) &&
      Array.isArray(layout.groupsConfig.fixProperty) &&
      layout.groupsConfig.fixProperty.length > 0
    ) {
      if (this._fixProperty.length === 0) {
        this._fixProperty = cloneDeep(layout.groupsConfig.fixProperty);
      } else {
        let Fp = layout.groupsConfig.fixProperty;
        let rFp = cloneDeep(this._fixProperty);

        [...rFp].forEach((i, rfp) => {
          if (
            (!fJS.searchTree(rfp, ['row']) || !fJS.isNumeric(rfp.row) || rfp.row < 0) &&
            (!fJS.searchTree(rfp, ['column']) || !fJS.isNumeric(rfp.column) || rfp.column < 0)
          )
            throw 'Błędna konfiguracja fixProperty w rules: column: ' + rfp.column + ', row: ' + rfp.row;
          this._fixProperty = merge(
            this._fixProperty,
            [...Fp]
              .flatMap((fp) => {
                if (
                  (!fJS.searchTree(fp, ['row']) || !fJS.isNumeric(fp.row) || fp.row < 0) &&
                  (!fJS.searchTree(fp, ['column']) || !fJS.isNumeric(fp.column) || fp.column < 0)
                )
                  throw 'Błędna konfiguracja fixProperty w groupsConfig: column: ' + fp.column + ', row: ' + fp.row;

                return fp;
              })
              .filter(([i, fp]) => !(rfp.row == fp.row && rfp.column == fp.column))
          );
        });
      }
    }

    this._combineGroups = cloneDeep(
      fJS.isNotEmptyObject(this.config.configGame.rulesGame.combineGroups)
        ? this.config.configGame.rulesGame.combineGroups
        : {}
    );
    // let test = this.layout;

    this._loadRule(rules, {
      rules: this.config.configGame.rulesGame,
      shuffle: rules.itemsConfig && rules.itemsConfig.shuffle === true ? true : false,
      shuffle2: -1,
      sort: rules.itemsConfig && rules.itemsConfig.sort === true ? true : false,
      sort2: -1,
      block:
        rules.itemsConfig && typeof rules.itemsConfig.block === 'boolean'
          ? rules.itemsConfig.block
          : this.defConfig.itemsConfig.block,
      block2: -1,
      layout: defaultsDeep(
        { groupsConfig: {}, itemsConfig: {} },
        { groupsConfig: layout?.groupsConfig, itemsConfig: layout?.itemsConfig }
      ),
      otherProperty: defaultsDeep({}, { ...layout?.otherProperty }),
    });

    cjsGroup.prototype.setCorrects(this.groups);

    if (typeof this._combineGroups === 'object' && Object.keys(this._combineGroups).length >= 1) {
      if (!Array.isArray(this._combineGroups.items) || this._combineGroups.items.length === 0)
        throw 'Brak konfiguracji tablicy items z id grup do złączenia';
      this._createCombineGroup();
    }

    this._createStage();
    this._setCorrectDepthForGroups();
  }

  _setCorrectDepthForGroups() {
    let elem;
    Object.entries(this.groups).forEach(([gr, group]) => {
      let index = this.stage.getChildIndex(group._container);

      this._setIndexGroup(group, index);
      this._setIndexGroup(group, index, true);
    });
  }

  _setIndexGroup(group, index, over) {
    let index1 = -1;
    let elem;
    Object.entries(group.items)
      .flatMap(([k, o]) => o)
      .filter((o) => (over === true ? !isNil(o?._otherProperty?.setOver) : !isNil(o?._otherProperty?.setUnder)))
      .filter((o) => {
        let sets =
          over === true
            ? isArray(o._otherProperty.setOver)
              ? o._otherProperty.setOver
              : isString(o._otherProperty.setOver)
              ? o._otherProperty.setOver
              : false
            : isArray(o._otherProperty.setUnder)
            ? o._otherProperty.setUnder
            : isString(o._otherProperty.setUnder)
            ? o._otherProperty.setUnder
            : false;

        if (sets === false) return false;

        if (isString(sets)) {
          index1 = this._findIndexGroupStage(sets);
          elem = this.groups[sets];
          return over === true ? index < index1 : index > index1;
        }

        let find = sets.reduce((p, c) => {
          let i1 = this._findIndexGroupStage(p);
          let i2 = this._findIndexGroupStage(c);
          return over === true ? (i1 > i2 ? p : c) : i1 < i2 ? p : c;
        });

        elem = this.groups[find];
        index1 = this.stage.getChildIndex(this.groups[find]?._container);

        return over === true ? index < index1 : index > index1;
      })
      .forEach((item) => {
        this.stage.setChildIndex(item._container, index1);
        this.stage.setChildIndex(elem._container, index);
      });
  }

  _findIndexGroupStage(search) {
    let elem = Object.values(this.groups).find((group) => group.id == search);
    if (!elem) {
      throw (
        'Nie ma na scenie elementu: ' +
        search +
        ', z którego mają być pobrane współrzędne dla elementu: ' +
        o.id +
        ' z grupy: ' +
        o.idGroup
      );
    }

    return this.stage.getChildIndex(elem?._container);
  }

  _loadRule(rules, sets) {
    if (typeof rules.combineGroups === 'object' || rules.combineGroups === null) {
      if (Object.keys(rules.combineGroups).length < 1 || rules.combineGroups === null) {
        this._combineGroups = {};
      } else {
        this._combineGroups = cloneDeep(rules.combineGroups);
      }
    }
    let itemsLength = Array.isArray(rules.items) ? rules.items.length : 0;
    let pickItems = fJS.isNumeric(rules.pickItems) && rules.pickItems <= itemsLength ? rules.pickItems : itemsLength;
    let idGroup = rules.idGroup ? rules.idGroup : null;
    let idItem = rules.idItem ? rules.idItem : null;

    if ((idGroup === null && idItem !== null) || (idGroup !== null && idItem === null)) {
      throw (
        'Błędna konfiguracja gry. Brakuje ustalenia ' +
        (idGroup === null ? 'idGroup dla idItem: ' + idItem : 'idItem dla idGroup: ' + idGroup)
      );
    }

    let layoutGroup = idGroup !== null ? this._findLayoutGroup(idGroup) : false;
    let layoutItem =
      idItem !== null
        ? this._findLayoutItem(idItem, idGroup, layoutGroup !== false ? layoutGroup.items : undefined)
        : false;

    if (layoutGroup === false && idGroup !== null) throw "Brakuje konfiguracji layout'u dla grupy " + idGroup;
    if (layoutGroup !== false) delete layoutGroup.idGroup;
    if (idGroup !== null) {
      this._shuffleGroups = typeof rules.shuffleGroups === 'boolean' ? rules.shuffleGroups : this._shuffleGroups;
      if (rules.groupsConfig && rules.groupsConfig.positions && Array.isArray(rules.groupsConfig.positions.fixTab))
        this._fixTab = merge(this._fixTab, rules.groupsConfig.positions.fixTab);
      if (rules.groupsConfig && Array.isArray(rules.groupsConfig.fixProperty))
        this._fixProperty = merge(this._fixProperty, rules.groupsConfig.fixProperty);
      this._setGroupConfig(idGroup, sets, layoutGroup, rules);
    }

    if (idItem !== null) {
      this._setItemConfig(idGroup, idItem, layoutGroup, layoutItem, rules, sets);
    }

    this._setOffsetGroups(sets, layoutGroup, rules);

    if (idGroup !== null) {
      this.groups[idGroup].setOffsetItems(this, layoutGroup, rules, sets);
    }

    if (sets.block2 !== -1) {
      sets.block = sets.block2;
      sets.shuffle = sets.shuffle2;
      sets.sort = sets.sort2;
    }

    sets.block =
      rules.itemsConfig && typeof rules.itemsConfig.block === 'boolean' ? rules.itemsConfig.block : sets.block;

    if (Array.isArray(rules.items) && rules.items.length > 0) {
      let indx = [];
      if (sets.shuffle) {
        indx = Array.from({ length: rules.items.length }, (v, k) => k);
        indx = sampleSize(indx, pickItems);
      } else {
        indx = Array.from({ length: pickItems }, (v, k) => k);
      }

      /** @typedef {(boolean)} czy elementy mają być posortowane? */
      if (sets.sort === true) {
        let copy = cloneDeep(indx);
        copy.sort(function (a, b) {
          return a - b;
        });
        indx = cloneDeep(copy);
      }

      let self = this;
      indx.forEach(function (ind, i) {
        let shuffle2 = rules.items[ind].itemsConfig && rules.items[ind].itemsConfig.shuffle === true ? true : false;
        let sort2 = rules.items[ind].itemsConfig && rules.items[ind].itemsConfig.sort === true ? true : false;
        let block2 = rules.items[ind].itemsConfig && rules.items[ind].itemsConfig.block === true ? true : false;
        sets = Object.assign({}, sets, { shuffle2, sort2, block2 });
        self._loadRule(rules.items[ind], cloneDeep(sets));
      });

      if (Array.isArray(rules.itemsGarbage)) {
        this._addGarbage(rules, cloneDeep(sets));
      }
    }
  }

  _addGarbage(rules, sets) {
    [...rules.itemsGarbage].forEach((rule, i, map, keysRest = new Map(), gr = this._findLayoutGroup(rule.idGroup)) => {
      if (gr === false) throw "Brakuje konfiguracji layout'u dla grupy " + rule.idGroup;

      console.log(Object.keys(this.groups).indexOf(gr.idGroup));
      if (Object.keys(this.groups).indexOf(gr.idGroup) == -1) {
        let group = [...this.config.configGame.layout.groups].find((find) => find.idGroup === gr.idGroup);
        Object.values(group.items).forEach((item) => {
          this._loadRule(
            merge(rule, {
              idItem: item.id,
            }),
            merge(
              sets,
              typeof rule.itemsConfig === 'object' && typeof rule.itemsConfig.block === 'boolean'
                ? { block: rule.itemsConfig.block }
                : {}
            )
          );
        });
        this.groups[gr.idGroup].setOffsetItems(this, gr, rules, sets);
      }

      let groupsRules = Object.values(gr.items).reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
      let merged = Object.values(groupsRules).filter((d) => !fJS.isNotEmptyObject(this.groups[gr.idGroup].items[d])),
        pickItems = fJS.isNumeric(rule.pick) && rule.pick <= merged.length ? rule.pick : merged.length;
      merged = sampleSize(merged, pickItems);
      let baseIndx = shuffle(merged);
      if (merged.length === baseIndx.length && merged.every((v, i) => v === baseIndx[i])) {
        baseIndx = reverse(baseIndx);
      }
      merged = baseIndx;
      merged.forEach((item) => {
        this._setItemConfig(
          gr.idGroup,
          item.id,
          gr,
          this._findLayoutItem(item.id, gr.idGroup, this.groups[gr.idGroup].items),
          typeof rule === 'object' ? rule.itemsConfig : null,
          sets
        );
      });
    });
  }

  _setOffsetGroups(sets, layoutGroup, rules) {
    if (
      sets.layout &&
      sets.layout.groupsConfig &&
      sets.layout.groupsConfig.positions &&
      fJS.isNotEmptyObject(sets.layout.groupsConfig.positions.offset)
    ) {
      this._checkOffsetGroup(sets.layout.groupsConfig.positions.offset);
    }
    if (layoutGroup && layoutGroup.positions && fJS.isNotEmptyObject(layoutGroup.positions.offset)) {
      this._checkOffsetGroup(layoutGroup.positions.offset);
    }
    if (
      sets.rules &&
      sets.rules.groupsConfig &&
      sets.rules.groupsConfig.positions &&
      fJS.isNotEmptyObject(sets.rules.groupsConfig.positions.offset)
    ) {
      this._checkOffsetGroup(sets.rules.groupsConfig.positions.offset);
    }
    if (
      rules &&
      rules.groupsConfig &&
      rules.groupsConfig.positions &&
      fJS.isNotEmptyObject(rules.groupsConfig.positions.offset)
    ) {
      this._checkOffsetGroup(rules.groupsConfig.positions.offset);
    }
  }

  _checkOffsetGroup(tab) {
    let self = this;
    this._offsetGroups.splice(0, this._offsetGroups.length);
    if (Array.isArray(tab)) {
      tab.forEach(function (off) {
        self._offsetGroups.push({
          x: fJS.isNumeric(off.x) ? off.x : self.defConfig.container.offset.x,
          y: fJS.isNumeric(off.y) ? off.y : self.defConfig.container.offset.y,
          column: off.column,
          row: off.row,
        });
      });
    } else {
      this._offsetGroups.push({
        x: fJS.isNumeric(tab.x) ? tab.x : this.defConfig.container.offset.x,
        y: fJS.isNumeric(tab.y) ? tab.y : this.defConfig.container.offset.y,
        column: tab.column,
        row: tab.row,
      });
    }
  }

  _setGroupConfig(idGroup, sets, layoutGroup, rules) {
    if (!fJS.isNotEmptyObject(this.groups[idGroup])) {
      this.groups[idGroup] = new cjsGroup({
        id: idGroup,
        block: sets.block,
        sort: sets.sort,
        shuffle: sets.shuffle,
        stage: this,
      });
    }
    let group = this.groups[idGroup];

    group.setLayout('background', sets, layoutGroup, rules);
    group.setLayout('positions', sets, layoutGroup, rules);
    group.setLayout('shadow', sets, layoutGroup, rules);

    if (group.layout.positions && Array.isArray(group.layout.positions.fixTab))
      group._fixTab = cloneDeep(group.layout.positions.fixTab);

    group.setMargin('padding', sets, layoutGroup, rules);
    if (!group.isAbsolute()) {
      group.setMargin('margin', sets, layoutGroup, rules);
    }
  }

  _setItemConfig(idGroup, idItem, layoutGroup, layoutItem, rules, sets) {
    let group = this.groups[idGroup];
    let rule = rules && Array.isArray(rules.correct) ? cloneDeep(rules.correct) : [];
    if (!fJS.isNotEmptyObject(group.items[idItem])) {
      group.addItem({
        id: idItem,
        block:
          rules && typeof rules.block === 'boolean' ? rules.block : sets ? sets.block : this.groups.get(idGroup).block,
        correct: rule,
        stage: this,
      });
    }

    let correct = new Map(
      Object.entries(
        rule.reduce((map, obj, idx) => {
          map[idx] = obj;
          return map;
        }, {})
      )
    );

    [...correct]
      .filter(
        ([k, c]) =>
          !fJS.searchTree(this.groups[c.idGroup].items[c.idItem].correct, [idGroup]) ||
          (fJS.searchTree(this.groups[c.idGroup].items[c.idItem].correct, [idGroup]) &&
            !isEqual(c, this.groups[c.idGroup].items[c.idItem]))
      )
      .map(([k, c]) =>
        this.groups[c.idGroup].items[c.idItem].correct.push(merge(cloneDeep(c), { idGroup: idGroup, idItem: idItem }))
      );

    let item = group.items[idItem];

    item.setLayout('background', sets, layoutGroup, layoutItem, rules);
    item.setLayout('positions', sets, layoutGroup, layoutItem, rules);
    item.setLayout('shadow', sets, layoutGroup, layoutItem, rules);

    item.setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules);

    if (item.layout.positions && fJS.isNumeric(item.layout.positions.columns) && item.layout.positions.columns > 0) {
      group.cols = item.layout.positions.columns;
      delete item.layout.positions.columns;
    }
    if (item.layout.positions && fJS.isNumeric(item.layout.positions.rows) && item.layout.positions.rows > 0) {
      group.rows = item.layout.positions.rows;
      delete item.layout.positions.rows;
    }

    item.setMargin('padding', sets, layoutGroup, layoutItem, rules);
    if (!item.isAbsolute()) {
      item.setMargin('margin', sets, layoutGroup, layoutItem, rules);
    }
  }

  _findLayoutGroup(idGroup) {
    let find = this.config.configGame.layout.groups.find((layout) => layout.idGroup == idGroup);
    return fJS.isNotEmptyObject(find) ? cloneDeep(find) : false;
  }

  _findLayoutItem(idItem, idGroup, groupItems) {
    let layout = false;
    if (Array.isArray(groupItems) === false) {
      let find = this._findLayoutGroup(idGroup);
      if (fJS.isNotEmptyObject(find)) groupItems = this._findLayoutGroup(idGroup).items;
    }

    if (Array.isArray(groupItems)) {
      let find = groupItems.find((item) => item.id === idItem);
      if (fJS.isNotEmptyObject(find)) {
        layout = cloneDeep(find);
        delete layout.id;
      }
    } else throw 'Brakuje konfiguracji tablicy items dla grupy: ' + idGroup;

    if (layout === false) throw 'Brakuje konfiguracji elementu: ' + idItem + ' w tablicy items dla grupy: ' + idGroup;
    return layout;
  }

  _createCombineGroup() {
    let self = this,
      newGroup = '',
      items = [...this._combineGroups.items].map((group) => {
        console.log(group);
      });
    this._combineGroups.items.forEach(function (id) {
      if (typeof self.groups[id] !== 'object' || self.groups[id] === null) throw 'Brak grupy o ID: ' + id;
      newGroup += id;
      items = merge(items, self.groups[id].items);
    });

    if (typeof self.groups[newGroup] === 'object' && self.groups[newGroup] !== null) {
      let i = 0;
      while (typeof self.groups[newGroup + i] === 'object' && self.groups[newGroup + i] !== null) {
        i++;
      }
      newGroup += i;
    }

    for (let gr in this.groups) {
      for (let it in this.groups[gr].items) {
        if (Array.isArray(this.groups[gr].items[it].correct) && this.groups[gr].items[it].correct.length > 0) {
          for (let i = 0; i < this.groups[gr].items[it].correct.length; i++) {
            if (this._combineGroups.items.indexOf(this.groups[gr].items[it].correct[i].idGroup) !== -1)
              this.groups[gr].items[it].correct[i].idGroup = newGroup;
          }
        }
      }
    }

    this._setGroupConfig(
      newGroup,
      {
        block:
          this._combineGroups.groupsConfig && typeof this._combineGroups.groupsConfig.block === 'boolean'
            ? this._combineGroups.groupsConfig.block
            : this.config.configGame.rulesGame.itemsConfig &&
              typeof this.config.configGame.rulesGame.itemsConfig.block === 'boolean'
            ? this.config.configGame.rulesGame.itemsConfig.block
            : this.defConfig.itemsConfig.block,
        shuffle:
          this._combineGroups.groupsConfig && typeof this._combineGroups.groupsConfig.shuffle === 'boolean'
            ? this._combineGroups.groupsConfig.shuffle
            : this.config.configGame.rulesGame.itemsConfig &&
              typeof this.config.configGame.rulesGame.itemsConfig.shuffle === 'boolean'
            ? this.config.configGame.rulesGame.itemsConfig.shuffle
            : this.defConfig.itemsConfig.shuffle,
        sort:
          this._combineGroups.groupsConfig && typeof this._combineGroups.groupsConfig.sort === 'boolean'
            ? this._combineGroups.groupsConfig.sort
            : this.config.configGame.rulesGame.itemsConfig &&
              typeof this.config.configGame.rulesGame.itemsConfig.sort === 'boolean'
            ? this.config.configGame.rulesGame.itemsConfig.sort
            : this.defConfig.itemsConfig.sort,
        layout: this.config.configGame.layout,
        rules: this.config.configGame.rulesGame,
      },
      null,
      this._combineGroups
    );

    this.groups[newGroup]._items = cloneDeepWith(items, fJS.customizer);

    this._combineGroups.items.forEach(function (id) {
      delete self.groups[id];
    });

    delete this._combineGroups;
  }

  _createStage() {
    console.log(this.groups);

    let ab = 0,
      grR = Object.values(this.groups)
        .filter((group) => !group.isAbsolute())
        .flatMap((group) => {
          if (ab < this._fixTab.length) {
            if (!fJS.isNumeric(this._fixTab[ab].x) || !fJS.isNumeric(this._fixTab[ab].y))
              throw 'Błędna konfiguracja tablicy współrzędnych dla grup';
            group.pos.x = this._fixTab[ab].x;
            group.pos.y = this._fixTab[ab].y;
            group.type = 'absolute';
            ab++;
          }
          return group;
        })
        .filter((group) => {
          return ab >= this._fixTab.length;
        });
    let groups = Object.entries(this.groups)
      .map(([gr, group]) => {
        Object.entries(group.items).forEach(([i, item]) => {
          if (item.layout.positions.rotation < 0 || item.layout.positions.rotation > 360)
            throw (
              'Zakres obrotu elementu: ' +
              i +
              ' w grupie: ' +
              gr +
              ' musi być 0 - 360, a nie: ' +
              item.layout.positions.rotation
            );

          if (fJS.isNotEmptyObject(item.otherProperty.registrationPoint)) {
            item.container.regX = fJS.isNumeric(item.otherProperty.registrationPoint.x)
              ? item.otherProperty.registrationPoint.x
              : item.container.regX;
            item.container.regY = fJS.isNumeric(item.otherProperty.registrationPoint.y)
              ? item.otherProperty.registrationPoint.y
              : item.container.regY;
            item.container.x += item.container.regX;
            item.container.y += item.container.regY;
          }
          if (item.layout.positions.rotation > 0) {
            if (
              !fJS.isNotEmptyObject(item.otherProperty.registrationPoint) ||
              !fJS.isNumeric(item.otherProperty.registrationPoint.x)
            ) {
              item.container.regX = item.width / 2;
              item.container.regY = item.height / 2;
              item.container.x += item.container.regX;
              item.container.y += item.container.regY;
            }

            item.rotation = cloneDeep(item.layout.positions.rotation);
          }
        });

        return group;
      })
      .filter((group) => {
        return !group.isAbsolute();
      });

    if (groups.length > 0 && this._shuffleGroups) {
      groups = shuffle(groups);
    }

    if (!Array.isArray(grR)) {
      this._createGroupsItems();
      return;
    }

    let cols, rows;
    if (this.colsConfig <= 0 && this.rowsConfig <= 0) {
      cols = grR.length;
      rows = 1;
    } else if (this.colsConfig > 0) {
      cols = grR.length > this.colsConfig ? this.colsConfig : grR.length;
      rows = Math.ceil(grR.length / cols);
    } else {
      rows = grR.length > this.rowsConfig ? this.rowsConfig : grR.length;
      cols = Math.ceil(grR.length / rows);
    }

    Object.values(grR).forEach((group, i, map, w = 0, c = i % cols) => {
      if (i === 0) {
        group.pos.x =
          (group.pos && fJS.isNumeric(group.pos.x) ? group.pos.x : this.defConfig.container.x) + group.margin.left;
        group.pos.y = group.pos && fJS.isNumeric(group.pos.y) ? group.pos.y : this.defConfig.container.y;

        return;
      }
      if (c === 0) {
        w++;
        group.pos.x = map[i - cols].pos.x - map[i - cols].margin.left;
        group.pos.y = map[i - cols].pos.y + map[i - cols].pos.height - map[i - cols].margin.bottom;
        console.log(group);
      } else {
        group.pos.x = map[i - 1].pos.x + map[i - 1].pos.width + map[i - 1].margin.right;
        group.pos.y =
          w === 0
            ? map[i - 1].pos.y - map[i - 1].margin.top - (i - cols - 1 >= 0 ? map[i - cols - 1].margin.bottom : 0)
            : map[i - cols].pos.y +
              map[i - cols].pos.height -
              (i - cols - 1 >= 0 ? map[i - cols - 1].margin.bottom : 0);
      }

      group.pos.x += group.margin.left;
      group.pos.y += group.margin.top + (i - cols >= 0 ? map[i - cols].margin.bottom : 0);
    });

    let w = 0;
    Object.values(grR).forEach((group, i, map, c = i % cols) => {
      if (i > 0 && c === 0) {
        w++;
      }
      this._offsetGroups.forEach(function (off) {
        if (
          (!fJS.isNumeric(off.row) || (fJS.isNumeric(off.row) && w === off.row)) &&
          (!fJS.isNumeric(off.column) || (fJS.isNumeric(off.column) && c === off.column))
        ) {
          group.pos.x += off.x;
          group.offset.x = off.x;
          group.pos.y += off.y;
          group.offset.y = off.y;
        }
      });

      if (this._fixProperty.length === 0) {
        return;
      }

      Object.values(this._fixProperty)
        .map((fix) => fix)
        .filter((fix) => {
          return (
            (!fJS.isNumeric(fix.row) || (fJS.isNumeric(fix.row) && w === fix.row)) &&
            (!fJS.isNumeric(fix.column) || (fJS.isNumeric(fix.column) && c === fix.column))
          );
        })
        .map((fix) => {
          Object.values(group.items).forEach((item) => {
            item._otherProperty = mergeWith(cloneDeep(fix.otherProperty), item._otherProperty);
          });
        });
    });

    this._createGroupsItems();

    Object.values(this.groups).forEach((group) => {
      this.stage.addChild(group.container);
    });
  }

  _createGroupsItems() {
    Object.values(this.groups).forEach((group) => {
      Object.values(group.items).forEach((item) => item.create());
      group.arrangeItems('items');
      group.create();
      this.stage.addChild(group.container);
    });
  }

  _setOffsetStage() {
    this._width = fJS.isNumeric(this.config.realWidth)
      ? this.config.realWidth
      : document.getElementById('game-container') !== null
      ? document.getElementById('game-container').offsetWidth
      : $(this.stage.canvas).parent()[0].offsetWidth;
    this._height = fJS.isNumeric(this.config.realHeight)
      ? this.config.realHeight
      : document.getElementById('game-container') !== null
      ? document.getElementById('game-container').offsetHeight
      : $(this.stage.canvas).parent()[0].offsetHeight;
    this.stage.canvas.width = this.width;
    this.stage.canvas.height = this.height;

    /**
     * Wyliczenie offset'u niezbędnego, żeby układ współrzędnych sceny znajdował się w punkcie 0,0, a nie na środku ekranu
     */
    this._offset = {
      x: this.stage.canvas.width / 2,
      y: this.stage.canvas.height / 2,
    };

    this.stage.x = this._offset.x;
    this.stage.y = this._offset.y;
  }

  _setStage() {
    this._setOffsetStage();

    this._removeInCorrects =
      typeof this.config.configGame.removeInCorrects === 'boolean'
        ? this.config.configGame.removeInCorrects
        : this.defConfig.removeInCorrects;
    this._backToSource =
      typeof this.config.configGame.backToSource === 'boolean'
        ? this.config.configGame.backToSource
        : this.defConfig.backToSource;
    this._bruteForce =
      typeof this.config.configGame.bruteForce === 'boolean'
        ? this.config.configGame.bruteForce
        : this.defConfig.bruteForce;
    this._correctBlock =
      typeof this.config.configGame.correctBlock === 'boolean'
        ? this.config.configGame.correctBlock
        : this.defConfig.correctBlock;
    this._autoCheckAllCorrect =
      typeof this.config.configGame.autoCheckAllCorrect === 'boolean'
        ? this.config.configGame.autoCheckAllCorrect
        : false;
    this._removeAllFromBadTarget =
      typeof this.config.configGame.removeAllFromBadTarget === 'boolean'
        ? this.config.configGame.removeAllFromBadTarget
        : false;
    this._removeAllForBadCount =
      typeof this.config.configGame.removeAllForBadCount === 'boolean'
        ? this.config.configGame.removeAllForBadCount
        : false;

    if (this.config.mainText !== null && typeof this.config.mainText === 'object') {
      var html = document.createElement('div');
      html.id = 'canvasBgr';
      html.innerHTML = this.config.mainText.text;
      this.setPropertyStyle(
        html,
        merge(
          {
            //            'position': 'absolute',
            //            'left': '0',
            //            'top': '0',
            //            'width': '100%',
            //           'height': '100%',
            //            'background-size': 'contain',
            //            'background-repeat': 'no-repeat'
          },
          this._mixins.getCustomStyle(this.config.mainText)
        )
      );

      document.getElementById('mainImage').appendChild(html);
      let gg = new createjs.DOMElement(html);
      gg.x =
        (typeof this.config.mainText.positions === 'object' && fJS.isNumeric(this.config.mainText.positions.x)
          ? this.config.mainText.positions.x
          : 0) - this.offset.x;
      gg.y =
        (typeof this.config.mainText.positions === 'object' && fJS.isNumeric(this.config.mainText.positions.y)
          ? this.config.mainText.positions.y
          : 0) - this.offset.y;
      if (
        typeof this.config.mainText.positions === 'object' &&
        fJS.isNumeric(this.config.mainText.positions.width) &&
        this.config.mainText.positions.width > 0
      )
        gg.width = this.config.mainText.positions.width;
      if (
        typeof this.config.mainText.positions === 'object' &&
        fJS.isNumeric(this.config.mainText.positions.height) &&
        this.config.mainText.positions.height > 0
      )
        gg.height = this.config.mainText.positions.height;
      this.stage.addChildAt(gg, 0);
      this.stage.update();
    }
  }

  _checkEngine(id) {
    if (id == undefined || id == false || id.length == 0) {
      throw 'Nie ma określonego ID gry';
      return false;
    }
    this._id = id;
    switch (id.toLowerCase()) {
      case 'clock':
        this._engine = 'cjsClock';
        break;
      case 'connect':
        this._engine = 'cjsConnect';
        break;
      case 'rotate':
        this._engine = 'cjsRotate';
        break;
      case 'dnd':
        this._engine = 'cjsDnD';
        break;
      case 'mixer':
        this._engine = 'cjsMixer';
        break;
      case 'sorting':
        this._engine = 'cjsSorting';
        break;
      case 'select':
        this._engine = 'cjsSelect';
        break;
      case 'puzzle':
        this._engine = 'cjsPuzzle';
        break;
      case 'memo':
        this._engine = 'cjsMemo';
        break;
      case 'hangman':
        this._engine = 'cjsHangman';
        break;
      /*     case 'mahjong':
             //              if (this._engine === undefined) this._engine = 'cjsMahjong';
             //              this._inLine = (this._initData.inLine === true) ? true : false;
             //              this._isHidden = (this._initData.isHidden === true) ? true : false;
             //              this._isSelected = { check: false, gr: -1, idx: -1 };
             //              this.matrix = [];
             break; */
      case 'maze':
        this._engine = 'cjsMaze';
        break;
      case 'mazedraw':
        this._engine = 'cjsMazeDraw';
        break;
      case 'tracedraw':
        this._engine = 'cjsTraceDraw';
        break;
    }

    if (this._engine === undefined || this._engine === false) {
      throw 'Nie ma takiej gry';
    } else {
      return true;
    }
  }

  _animate(move, stop) {
    if (!stop.move) {
      return;
    }
    let count = this.defConfig.speedAnimate;

    if (Math.abs(move.x - stop.x) < count) move.x = stop.x;

    if (move.x < stop.x) move.x += count;
    else if (move.x > stop.x) move.x -= count;

    if (Math.abs(move.y - stop.y) < count) move.y = stop.y;

    if (move.y < stop.y) move.y += count;
    else if (move.y > stop.y) move.y -= count;

    if (typeof stop.scaleX != undefined && stop.scaleX != null) {
      let count = 0.1;
      if (Math.abs(move.scaleX - stop.scaleX) < count) move.scaleX = stop.scaleX;

      if (move.scaleX < stop.scaleX) move.scaleX += count;
      else if (move.scaleX > stop.scaleX) move.scaleX -= count;
    }
    if (typeof stop.scaleY != undefined && stop.scaleY != null) {
      let count = 0.1;
      if (Math.abs(move.scaleY - stop.scaleY) < count) move.scaleY = stop.scaleY;

      if (move.scaleY < stop.scaleY) move.scaleY += count;
      else if (move.scaleY > stop.scaleY) move.scaleY -= count;
    }

    move.container.updateCache();
  }
}

export const games = {
  //    cjsMahjong,
  cjsDnD,
  cjsSorting,
  cjsRotate,
  cjsConnect,
  cjsClock,
  cjsSelect,
  cjsPuzzle,
  cjsMemo,
  cjsHangman,
  cjsMaze,
  cjsMazeDraw,
  cjsTraceDraw,
  cjsMixer,
};
